import {join, reject} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import type {CommonAddressResponseBody} from '../../../api/types/onlineOfferTypes';

export function formatTestDriveAddressLine(address: CommonAddressResponseBody): string {
  const numberPart = join(
    '/',
    reject(isNilOrEmpty, [address.descriptiveNumber, address.orientationNumber])
  );
  const streetAndNumber = isNilOrEmpty(numberPart)
    ? address.street
    : `${address.street} ${numberPart}`;

  return `${streetAndNumber}, ${address.zip} ${address.city}`;
}
